import { EErrorMessageMode } from "@kuika/kuika-cl-model";
import { Form } from "antd/es";
import { PureComponent, ReactNode } from "react";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { ConfigField } from "../config-pane-parts";

/** A fixed pair, so it is a constant rather than something fetched. */
const ERROR_MESSAGE_MODES: KuikaSelectboxOption[] = [
  { value: EErrorMessageMode.Detailed, label: "Detailed message" },
  { value: EErrorMessageMode.Simple, label: "Simple message" }
];

export interface IConfigErrorMessageModeProps {
  /** Parent config section this selector belongs to. Backend-side masking, so always "apiConfig". */
  parentData: string;
}

/**
 * Chooses how much of a failure the generated app shows its end users. `Simple` replaces the
 * body of any 5xx response with a generic, localized message, which keeps database, SMTP,
 * REST and custom-C# text out of the error toast; the 4xx family (KBadRequestException and
 * friends) still reaches the user verbatim. Either way the full detail is written to KLog.
 *
 * A configuration saved before the setting existed carries no `errorMessageMode`;
 * `normalizeApiConfigErrorMessageMode` gives it Detailed on load, and `getValueProps` shows
 * Detailed for whatever still arrives absent without writing it to the form store.
 */
export class ConfigErrorMessageMode extends PureComponent<IConfigErrorMessageModeProps> {
  render(): ReactNode {
    const { parentData } = this.props;
    const errorMessageModeFieldName: string[] = [parentData, "errorMessageMode"];

    return (
      <ConfigField label="Error Message Mode" tooltipContentKey="appsettings_errormessages_errormessagemode">
        <Form.Item
          name={errorMessageModeFieldName}
          getValueProps={(value) => ({ value: value ?? EErrorMessageMode.Detailed })}
        >
          <KuikaSelectbox
            size="md"
            data-testid={`${parentData}ErrorMessageModeDropdown`}
            options={ERROR_MESSAGE_MODES}
          />
        </Form.Item>
      </ConfigField>
    );
  }
}
